// extracted by mini-css-extract-plugin
export default {"ServerTitle":"ServerTitle_ServerTitle__f-14R","ServerHeading":"ServerTitle_ServerHeading__KopQR","ServerLogo":"ServerTitle_ServerLogo__cbAOf"};